<template>
  <iframe
    v-if="video.type === 'youtube'"
    :class="className"
    :src="`https://www.youtube.com/embed/${video.params.id}`"
    :title="title"
    allow="
      accelerometer;
      autoplay;
      clipboard-write;
      encrypted-media;
      gyroscope;
      picture-in-picture;
    "
    allowFullScreen
  />
  <video
    v-else
    :class="className"
    :poster="video.params.thumbnail"
    :title="title"
    controls
    playsinline
    preload="metadata"
  >
    <source :src="video.params.webm" type="video/webm" />
    <source :src="video.params.mp4" type="video/mp4" />
  </video>
</template>

<script lang="ts" setup>
type VideoValue =
  | { type: 'youtube'; params: { id: string } }
  | {
      type: 'cdn'
      params: { mp4: string; webm: string; thumbnail: string }
    }

defineProps<{
  className?: string
  title?: string
  video: VideoValue
}>()
</script>
